import userApi from '@/pages/User/user.api'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import { PropsWithChildren, useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import usePersistentState from '@/shared/hooks/usePersistentState'
import syncHistoryСonstants from './syncHistory.constants'

const SyncHistoryProvider = (props: PropsWithChildren) => {
  const [lastRoute, setLastRoute] = usePersistentState<string>('', 'syncHistoryProvider/lastRoute', 'localstorage')
  const location = useLocation()
  const { wait, loading } = useHttpLoader()

  const pushCurrentRoute = useCallback(() => {
    if (loading) return
    if (location.pathname === lastRoute) return
    if (syncHistoryСonstants.unsavedRoutes.includes(location.pathname)) return

    wait(userApi.addHistoryRoute(location.pathname))
    setLastRoute(location.pathname)
  }, [location, loading])

  useEffect(() => {
    pushCurrentRoute()
  }, [location])

  return props.children
}

export default SyncHistoryProvider
